<div class="clinician-portfolio-container">
  <div class="clinician-profile-name name">{{ name }}</div>
  <a
    class="clinician-profile-logout link"
    href="#"
    (click)="logout()"
    color="primary"
    translate
    >Logout</a
  >
</div>
